import { render } from "./Panel.vue?vue&type=template&id=0a27c87a&scoped=true"
import script from "./Panel.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Panel.vue?vue&type=script&charset=utf-8&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=0a27c87a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a27c87a"]])

export default __exports__